import * as React from 'react';
import { useId } from 'react';
import { StyleSheet } from 'react-native';
import Svg, { Defs, Ellipse, FeGaussianBlur, Filter, Rect } from 'react-native-svg';

import { Box } from '@/components/lib/components';

export const GlowShape = ({
    x,
    y,
    width,
    height,
    color,
    opacity,
    blur = 20,
    shape = 'oval',
    filterPadding,
}: {
    x: number;
    y: number;
    width: number;
    height: number;
    color: string;
    opacity: number;
    blur?: number;
    shape?: 'oval' | 'rect';
    filterPadding?: number;
}) => {
    const filterId = `glow-blur-${useId()}`;
    const filterRegion = filterPadding
        ? {
              filterUnits: 'userSpaceOnUse' as const,
              x: x - filterPadding,
              y: y - filterPadding,
              width: width + 2 * filterPadding,
              height: height + 2 * filterPadding,
          }
        : { x: '-50%', y: '-50%', width: '200%', height: '200%' };

    return (
        <Box style={[styles.glowContainer, { opacity }]} pointerEvents={'none'}>
            <Svg style={styles.svg}>
                <Defs>
                    <Filter id={filterId} {...filterRegion}>
                        <FeGaussianBlur stdDeviation={`${blur}`} />
                    </Filter>
                </Defs>
                {shape === 'oval' ? (
                    <Ellipse
                        cx={x + width / 2}
                        cy={y + height / 2}
                        rx={width / 2}
                        ry={height / 2}
                        fill={color}
                        filter={`url(#${filterId})`}
                    />
                ) : (
                    <Rect x={x} y={y} width={width} height={height} fill={color} filter={`url(#${filterId})`} />
                )}
            </Svg>
        </Box>
    );
};

const styles = StyleSheet.create({
    svg: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    glowContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        opacity: 0.3,
    },
});
